import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { CustomTextField } from "@totalsoft/rocket-webapp-components-deprecated";
import { emptyString } from "constants/defaultValues";
import { useTranslation } from "react-i18next";
import * as V from "@totalsoft/pure-validations";

function EmailAddressContent({ dialogState, setDialogState, validation }) {
  const { t } = useTranslation();

  const handleChange = useCallback(
    (event) => {
      setDialogState({ email: event.target.value });
    },
    [setDialogState]
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <CustomTextField
          fullWidth
          label={t("Product.EmailAddress")}
          value={dialogState.email || emptyString}
          onChange={handleChange}
          error={!V.isValid(validation.email)}
          helperText={V.getErrors(validation.email)}
        />
      </Grid>
    </Grid>
  );
}

EmailAddressContent.propTypes = {
  dialogState: PropTypes.object.isRequired,
  setDialogState: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
};

export default EmailAddressContent;
